import React, { Component } from "react";

class SignUpInput extends Component {
  render() {
    const {
      label,
      type = "string",
      name,
      onChange,
      placeholder,
      required
    } = this.props;
    return (
      <div className="form-row">
        <label htmlFor="email">
          {label}
          {required ? " *" : ""}
        </label>
        <input
          type={type}
          name={name}
          id={`sign_up_form_${name}`}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
        />
      </div>
    );
  }
}

export default SignUpInput;



// WEBPACK FOOTER //
// src/views/sign-up-agency/input.js